import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAIAgentsUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (customer: string, lob: string, channel: string): Promise<any> => {
        return await this._aiRepository.getAIAgents(customer, lob, channel);
    }
}

export const GetAIAgentsUseCaseName = "GetAIAgentsUseCaseName";